import React from 'react';
import { ReportSearchHighlight } from '../ReportSearchHighlight/ReportSearchHighlight';

export const PerformanceRuleExecutedActionRuleNameCellRenderer = ({ data: { ruleName, ruleId }, isSearchable }) => {
    const message = `${ruleName} (ID: ${ruleId})`;
    return isSearchable && message ? <ReportSearchHighlight text={String(message)} /> : message;
};
